import BookingsSerializer from './base';

export default class Slot extends BookingsSerializer {}
